"use client";

import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  Typography,
  TextField,
  Box,
  Button,
} from "@mui/material";
import fetchWithAuth from "../../../util/fetchWithAuth";
import { API_URL } from "../../../util/url";

const CardModal = ({ open, onClose, cardValue, setCardValue, userData }) => {
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState(null);
  const [messageType, setMessageType] = useState(null);
  const handleSave = async () => {
    if (cardValue.length !== 16) {
      setMessage("Номер картки має містити 16 цифр.");
      setMessageType("error");
      return;
    }

    setSaving(true);
    setMessage(null);

    try {
      const response = await fetchWithAuth(`${API_URL}/user/me/`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          card_number: cardValue,
          username: userData.username,
          combo_days: userData.combo_days,
          experience: userData.experience,
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        console.error(errorData);
        setMessage(
          "Помилка при збереженні картки: " +
            (errorData.detail || "Невідома помилка")
        );
        setMessageType("error");
      } else {
        setMessage("Картка успішно збережена!");
        setMessageType("success");
        setTimeout(() => {
          onClose?.();
        }, 1500);
      }
    } catch (err) {
      console.error(err);
      setMessage("Помилка при збереженні картки");
      setMessageType("error");
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogContent
        sx={{
          background: "#fff",
          color: "#232B3E",
          borderRadius: 3,
          p: 4,
          minWidth: 530,
          width: 530,
          maxWidth: 530,
          boxShadow: "0 2px 16px 0 rgba(0,0,0,0.08)",
          ".dark-theme &": {
            background: "#0C1427",
            color: "#fff",
          },
        }}
      >
        <Typography variant="h6" sx={{ fontWeight: 700, mb: 2 }}>
          Банківські реквізити
        </Typography>
        <Typography sx={{ mb: 2 }}>Ваша картка:</Typography>
        <TextField
          fullWidth
          variant="outlined"
          placeholder="Введіть номер картки"
          value={cardValue}
          onChange={(e) =>
            setCardValue(e.target.value.replace(/\D/g, "").slice(0, 16))
          }
          inputProps={{
            maxLength: 16,
            inputMode: "numeric",
            pattern: "[0-9]*",
          }}
          sx={{ mb: 3 }}
          disabled={saving}
        />
        {message && (
          <div
            className={`mt-3 p-2 rounded text-sm ${
              messageType === "error"
                ? "bg-red-100 text-red-700"
                : "bg-green-100 text-green-700"
            }`}
          >
            {message}
          </div>
        )}
        <Box sx={{ display: "flex", gap: 2, mt: 2 }}>
          {!cardValue && (
            <Button
              variant="contained"
              sx={{
                background: "#6366F1",
                borderRadius: "8px",
                textTransform: "none",
                fontWeight: 500,
              }}
              style={{ color: "white" }}
              onClick={handleSave}
              disabled={saving}
            >
              {saving ? "Збереження..." : "Зберегти"}
            </Button>
          )}

          <Button
            variant="text"
            sx={{ textTransform: "none", fontWeight: 500 }}
            onClick={onClose}
            disabled={saving}
          >
            Закрити
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default CardModal;
